module.exports = __webpack_public_path__ + "static/media/server.ee2001fb.svg";